import React, { FC, ReactChild } from 'react'
import { ZoomViewer as ZoomViewerUIKit } from '@mch-group/uikit-components'
import { cloudinary } from '@constants'
import { uploadTransformationUrl } from '@dmi-mch/utils'
import Image from './Image'
import ArtworkImageProps from '../../types/ArtworkImageProps'

const ZoomViewer: FC<TZoomViewer> = ({
  images,
  showDefaultView = true,
  videoPosition,
  totalCount,
  children,
  fillContainer,
  reducedSize = 2.5,
  title
}) => {
  const reducedHeight = (height) => Math.floor(height / reducedSize)
  const reducedWidth = (width) => Math.floor(width / reducedSize)
  return (
    //@ts-ignore
    <ZoomViewerUIKit.Gallery>
      {images?.map((item, i) => (
        <ZoomViewerUIKit.Item
          original={uploadTransformationUrl(item?.url || item?.src, 'w_auto,c_fill,q_auto,dpr_1.0,f_auto', {
            transformUrl: cloudinary.throughCloudfront
          })}
          thumbnail={uploadTransformationUrl(
            item?.url || item?.src,
            `w_${reducedWidth(item?.width)},h_${reducedHeight(item?.height)},c_fill,q_auto,dpr_1.0,f_auto`,
            { transformUrl: cloudinary.throughCloudfront }
          )}
          height={item?.height}
          width={item?.width}
          key={item.url}
          //@ts-ignore
          alt={item?.title || title}
        >
          {({ ref, open }) => (
            <>
              {showDefaultView ? (
                <Image
                  ref={ref}
                  src={uploadTransformationUrl(
                    item?.url,
                    `w_auto,h_${reducedHeight(item?.height)},c_fill,q_auto,dpr_1.0,f_auto`,
                    { transformUrl: cloudinary.throughCloudfront }
                  )}
                  totalCount={totalCount}
                  currentCount={videoPosition === 0 ? i + 2 : i + 1}
                  //@ts-ignore
                  alt={item?.title || title}
                  open={open}
                  fillContainer={fillContainer}
                />
              ) : (
                //@ts-ignore
                children({ ...item, open, ref, i })
              )}
            </>
          )}
        </ZoomViewerUIKit.Item>
      ))}
    </ZoomViewerUIKit.Gallery>
  )
}

type TZoomViewer = {
  // For some reason, images in this file have a "src" prop, which is not part of the usual Artwork Image.
  images: Array<ArtworkImageProps & { src: string }>
  showDefaultView?: boolean
  videoPosition: number
  totalCount: number
  children?: ReactChild
  fillBg?: boolean
  fillContainer?: boolean
  title?: string
  altText: string
  reducedSize?: number
}

export default ZoomViewer
